<template>
  <div class="adminWebsiteConfig">
    <CreateOrEditBanner
      ref="createOrEditDialog"
      :positionList="positionList"
      @submitDialog="GetTableList"
    />
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>广告</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('admin_tag.add')"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem"
          >{{l("新增")}}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row type="flex" align="middle" :gutter="20" style="margin-bottom: 15px">
        <el-col :span="4">
          <el-checkbox
            v-model="SearchData.show_pc"
            true-label="true"
            false-label=" "
            @change="GetTableList(true)"
            >电脑端可见</el-checkbox
          >
        </el-col>
        <el-col :span="4">
          <el-checkbox
            v-model="SearchData.show_app"
            true-label="true"
            false-label=" "
            @change="GetTableList(true)"
            >手机端可见</el-checkbox
          >
        </el-col>
        <el-col :span="4">
          <el-checkbox
            v-model="SearchData.is_show"
            true-label="true"
            false-label=" "
            @change="GetTableList(true)"
            >展示中</el-checkbox
          >
        </el-col>

        <el-col :span="4">
          <el-select size="mini" clearable v-model="SearchData.position">
            <el-option
              v-for="item in positionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>

      <!-- <el-tabs v-model="SearchData.position" type="card">
        <el-tab-pane
          v-for="item in positionList"
          :key="item.id"
          :label="item.name"
          :name="item.id"
        >
        </el-tab-pane>
      </el-tabs> -->

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => true,
              label: '编辑',
              command: 'EditItem',
            },
            {
              is_show: (row) => true,
              label: '删除',
              command: 'DeleteItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-image
              style="height: 40px; width: 100%"
              :src="scope.row.url"
              fit="contain"
              :preview-src-list="[scope.row.url]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="order_index" label="优先级"> </el-table-column>
        <el-table-column label="电脑端可见">
          <template slot-scope="scope">
            <span v-if="scope.row.show_pc">
              <i class="el-icon-check color-success"></i>
            </span>
            <span v-else>
              <i class="el-icon-close color-danger"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="手机端可见">
          <template slot-scope="scope">
            <span v-if="scope.row.show_app">
              <i class="el-icon-check color-success"></i>
            </span>
            <span v-else>
              <i class="el-icon-close color-danger"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.start_time ? scope.row.start_time.slice(0, 13) : "-" }}
          </template>
        </el-table-column>

        <el-table-column label="结束时间" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.end_time ? scope.row.end_time.slice(0, 13) : "-" }}
          </template>
        </el-table-column>

        <el-table-column label="展示中">
          <template slot-scope="scope">
            <span v-if="scope.row.is_show">
              <i class="el-icon-check color-success"></i>
            </span>
            <span v-else>
              <i class="el-icon-close color-danger"></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>




<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditBanner from "./operation/CreateOrEditBanner.vue";

export default {
  name: "AdminBanner",
  mixins: [tableMixin],
  components: {
    CreateOrEditBanner,
  },
  data() {
    return {
      SearchData: {
        position: "carousel",
        show_pc: null,
        show_app: null,
        is_show: null,
      },
      positionList: [
        { id: "carousel", name: "首页" },
        // { id: "carousel_beancurds", name: "首页豆腐块" },
        { id: "carousel_quotation", name: "现货卖场" },
        { id: "carousel_purchase_forging", name: "锻件定制" },
        { id: "carousel_purchase_material", name: "原料求购" },
        { id: "carousel_purchase_piece", name: "零切交易" },
        { id: "carousel_raise", name: "钢厂拼单" },
        { id: "inspect_business", name: "质检委托" },
      ],
    };
  },
  watch: {
    "SearchData.position"() {
      this.GetTableList(true);
    },
  },
  mounted() {
    this.axios
      .get("/api/tag/", {
        params: {
          module: "good_business",
          ordering: this.Sorting,
          size: 99,
          page: 1,
        },
      })
      .then((data) => {
        this.positionList.push(
          ...data.results.map((item) => ({
            id: "good_business_" + item.id,
            name: "优选_" + item.name,
          }))
        );
      });
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_banner/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    CreateItem() {
      this.$refs.createOrEditDialog.Type = "Create";
      this.$refs.createOrEditDialog.Show({
        position: this.SearchData.position,
      });
    },
    DeleteItem(item) {
      this.$confirm("是否删除选中广告?", "", {
        type: "warning",
      }).then(() => {
        this.axios.delete(`/api/admin_banner/${item.id}/`).then((response) => {
          this.GetTableList();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>

